export const getDialogContainer = (id: string) => {
  let div: any;
  if (!document.getElementById(id)) {
    div = document.createElement('div');
    div.id = id;
    document.body.appendChild(div);
  }
  return document.getElementById(id) as HTMLElement;
};
